var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartParallel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V17H17",
    stroke: "#A3AEB8",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 3.58289C4.55663 3.58289 4.88067 3.68935 5.21469 3.73008C5.6474 3.78285 6.02137 3.96513 6.37191 4.21552C6.76902 4.49917 7.0271 4.74589 7.24101 5.18954C7.44337 5.60925 7.59378 6.06989 7.72958 6.51432C7.86002 6.94121 8.09708 7.33726 8.19153 7.77803C8.25347 8.0671 8.34514 8.32427 8.44678 8.60015C8.58028 8.96252 8.80086 9.27915 8.96667 9.62583C9.15145 10.0122 9.216 10.4461 9.34876 10.8551C9.57831 11.5623 9.91132 12.4763 10.7205 12.6731C11.4284 12.8453 12.1459 12.8845 12.8705 12.8845C13.0981 12.8845 13.3979 12.898 13.5831 12.7499C13.6402 12.7042 13.7451 12.6907 13.8164 12.6591C13.8752 12.6329 14.0919 12.5871 14.1123 12.5463",
    stroke: "#CCE3F2",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16162 12.9805C4.32512 12.9805 4.4895 12.9859 4.65284 12.9805C4.84076 12.9742 5.0468 12.7952 5.2099 12.707C5.62236 12.4841 5.99426 12.0648 6.24299 11.6739C6.49491 11.2781 6.8776 10.9871 7.0887 10.5649C7.27767 10.187 7.50992 9.80749 7.73691 9.45078C7.93911 9.13304 8.10211 8.77722 8.28637 8.44554C8.43088 8.18544 8.45 7.88672 8.60542 7.62768C8.94898 7.05509 9.16215 6.418 9.45873 5.82484C9.72614 5.29001 9.96898 4.82426 10.4159 4.42207C10.5753 4.27853 10.8984 4.21824 11.0995 4.14861C11.3303 4.06873 11.579 4.02714 11.8136 3.93592C12.0394 3.84807 12.2521 3.84383 12.4795 3.77386C12.6993 3.70623 12.9319 3.63713 13.1632 3.63713C13.5192 3.63713 13.9089 3.59155 14.2798 3.59155",
    stroke: "#CCE3F2",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79248 2.74207V13.8225",
    stroke: "#338ECC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.873 3.04419V13.7217",
    stroke: "#338ECC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartParallel);
export default __webpack_public_path__ + "static/media/chart-parallel.da7dedf539b2af4b654d377c679173e4.svg";
export { ForwardRef as ReactComponent };